import { render } from "./ToastNotification.vue?vue&type=template&id=1b363290&scoped=true"
import script from "./ToastNotification.vue?vue&type=script&lang=js"
export * from "./ToastNotification.vue?vue&type=script&lang=js"

import "./ToastNotification.vue?vue&type=style&index=0&id=1b363290&scoped=true&lang=css"

import exportComponent from "C:\\Users\\darca\\dev\\spanish-ai\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b363290"]])

export default __exports__